module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-circle-10939f39d52a73b8924152637abba0fb.svg";